import { cn } from '@flowstate/utils';
import { BrandIcon, SimpleIconSlug } from "./BrandIcon";

export interface BrandLogoProps {
  name: string;
  slug?: SimpleIconSlug;
  icon?: React.ComponentType<{ className?: string }>;
  iconColor?: string;
  className?: string;
}

export function BrandLogo({
  name,
  slug,
  icon: CustomIcon,
  iconColor = "var(--primary)",
  className,
}: BrandLogoProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-3 px-5 py-3 rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm hover:bg-white/10 hover:border-primary/30 transition-all duration-300",
        className
      )}
    >
      {slug ? (
        <BrandIcon slug={slug} className="h-6 w-6" />
      ) : CustomIcon ? (
        <span style={{ color: iconColor }}>
          <CustomIcon className="h-6 w-6" />
        </span>
      ) : null}
      <span className="text-sm font-semibold text-foreground whitespace-nowrap">{name}</span>
    </div>
  );
}
